import { Conversation, Presence } from "@chatscope/use-chat";
import { SerializedError } from "@reduxjs/toolkit";
import { StaffMember } from "./tenants";
import { FacilityData } from "./facilities";
import { HKPhoto } from "./housekeeping";
import { PhotoInfo } from "./resident";

export enum Priority {
  EMERGENCY = "Emergency",
  IMPORTANT = "Important",
  STANDARD = "Standard",
}
export enum MessageType {
  TEXT = "Text",
  REACTION = "Reaction",
  IMAGE = "Image",
}

export enum ChatType {
  DIRECT = "Direct",
  GROUP = "Group",
}

export enum ParticipantRole {
  MEMBER = "Member",
  CREATOR = "Creator",
}

export const initialConversation: Conversation<any> = {
  id: "",
  participants: [],
  unreadCounter: 0,
  // typingUsers: [],
  draft: "",
  description: "",
  readonly: false,
  messages: [],
  lastMessage: undefined,
  createdTime: new Date().toISOString(),
  updatedTime: new Date().toISOString(),
};


export interface ChatState {
  record: Chat;
  loading: 'idle' | 'pending' | 'succeeded' | 'failed'
  isInitialized: boolean
  error: SerializedError | null
  
}

export interface Chat {
  contacts: StaffMemberRef[],
}

export interface StaffMemberRef {
  id?: string,
  staffRefId: string,
  role: string,
  name: string,
  email: string,
  tenantRefId: string
}

export interface Participant {
  user: StaffMemberRef,
  role: string,
  name: string,
  isRead: boolean
}

export interface Message {
  id: string;
  unreadCounter: number;
  participants: Participant[];
  // typingUsers: TypingUsersList;
  description: string;
  draft: string;
  readonly: boolean;
}

export interface ChatMessage {
    data: Message[];
}

export interface Reaction {
  sender: Participant,
  emoji: string,
  sendDate: string
}

export interface ChatMessagePayload {
  chatId?: string
  responseToId?: string,
  sender: StaffMemberRef,
  sendDate: string,
  messageType: MessageType,
  deleteDate?: string,
  priority: Priority,
  receivedList: Participant[],
  message: string,
  reactions?: Reaction[]
}

export interface ChatMessageResponse extends ChatMessagePayload {
  id: string,
  chatId: string
}

export interface MessageReactionPayload {
  id: string
  sender: StaffMemberRef,
  emoji: string,
  sendDate: string
}

export interface ChatPayload {
  id?: string
  chatType: MessageType
  participants: Participant[],
  lastActivityDate: string,
  deleteDate?: string,
  facility: FacilityData,
  lastMessageInfo?: LastMessageInfo
}

export interface ChatResponse extends ChatPayload {}

export interface ChatsQuery {
  facilityId: string
  tenantId: string
  participantId?: string
}

export interface ChatMessageQuery {
  facilityId: string
  chatId?: string
  startDate?: string,
  endDate?: string,
}

export type HandleSendMessageInput = {
  content: string,
  priority?: Priority,
  messageType: MessageType,
  photoData?: HKPhoto
};

export interface ChatMessageGroup {
  id: string;
  senderId: string;
  direction: "incoming" | "outgoing";
  messages: ChatMessage[];
}

export interface ChatMessageDateGroup {
  date: string;
  groups: ChatMessageGroup[];
}

export interface ChatMessageSignalRPayload {
  id: string,
  photoData?: PhotoInfo,
  chatId: string,
  senderId?: string,
  senderName?: string,
  sendDate: string,
  messageType: MessageType,
  priority: Priority,
  message?: string,
  reactions?: string,
  action?: string,
  emoji?: string,
  participantIds?: string[]
  recipientId?: string
}

export interface LastMessageInfo {
  sendDate?: string,
  message?: string,
  messageType?: MessageType
}

export interface ContactChat {
  id: string,
  facility: FacilityData,
  lastActivityDate?: string,
  lastMessageInfo?: LastMessageInfo,
  chatType?: string,
  dataType?: string,
  deleteDate?: string,
  participants?: Participant[];
}

export interface Contact {
  id: string,
  initials?: string,
  email?: string,
  name?: string,
  role?: string,
  isOnline?: boolean,
  lastActivityDate?: string,
  lastMessageInfo?: LastMessageInfo,
  chat?: ContactChat,
  presence?: Presence
}

export interface ContactWaiver {
  tenantId: string
  staffMemberId: string
  waiverConfig: boolean
}
